import { render, staticRenderFns } from "./Nominate.vue?vue&type=template&id=863788e2"
import script from "./Nominate.vue?vue&type=script&lang=js"
export * from "./Nominate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports